import { z } from 'zod';

export const AvailabilityAlertModalSchema = z.object({
  availabilityAlertActive: z.boolean(),
  minAvailability: z.number().int().nonnegative(),
  rollOffAlertActive: z.boolean(),
});

export type AvailabilityAlertModalType = z.infer<
  typeof AvailabilityAlertModalSchema
>;
